import { render, staticRenderFns } from "./viewerArea.vue?vue&type=template&id=4d3c54bf&scoped=true&"
import script from "./viewerArea.vue?vue&type=script&lang=js&"
export * from "./viewerArea.vue?vue&type=script&lang=js&"
import style0 from "./viewerArea.vue?vue&type=style&index=0&id=4d3c54bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3c54bf",
  null
  
)

/* custom blocks */
import block0 from "./viewerArea.vue?vue&type=custom&index=0&blockType=comment"
if (typeof block0 === 'function') block0(component)

export default component.exports